'use strict';

module.exports = String.prototype.includes;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/string/var/nativeIncludes.js
// module id = 950
// module chunks = 0